<template>
  <div id="app">
    <public v-if="publicRoute" />
    <authed v-else-if="isLoggedIn" />
    <guest v-else />
  </div>
</template>
<script>
import { debounce } from "lodash";
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";
import Authed from "./layouts/Authed";
import Guest from "./layouts/Guest";
import Public from "./layouts/Public.vue";
import { activeTheme, applyTheme } from "@/utils/theme";

export default {
  components: {
    Authed,
    Guest,
    Public,
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.authenticated,
      authedUser: (state) => state.auth.user,
      termsAcceptedDate: (state) => state.auth.user?.terms_accepted_date,
    }),
    publicRoute: function () {
      return this.$route.meta.public;
    },
  },
  created() {
    this.updateDeviceType();
    window.addEventListener("resize", debounce(this.updateDeviceType, 500));
    this.updateSystemUI();
    this.getProfileLogo();
    this.checkIfUserLoggedIn()
      .then((res) => {
        if (res) {
          if (!this.authedUser) {
            this.getUserDetails().then(() => {
              this.getCompanyProfile();
              this.getOneChartNotesInfo();
              this.showPrivacyModal();
            });
          }
        } else {
          this.doLogout();
        }
      })
      .catch((err) => {
        //eslint-disable-next-line
        console.log(err);
      });
  },
  methods: {
    ...mapActions({
      checkIfUserLoggedIn: "auth/setLoggedIn",
      getUserDetails: "auth/getUser",
      getProfileLogo: "settings/getCompanyProfileLogo",
      getDeviceType: "settings/getDeviceType",
      getOneChartNotesInfo: "oneai/getOneChartNotesInfo",
      getNotifications: "users/getNotifications",
      getCompanyProfile: "settings/getCompanyProfile",
      setAcceptTerms: "auth/setAcceptTerms",
      doLogout: "auth/logout",
    }),
    updateDeviceType: function () {
      this.getDeviceType();
    },
    updateSystemUI: function () {
      applyTheme(activeTheme());
    },
    showPrivacyModal: function () {
      if (!this.termsAcceptedDate) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-black",
            cancelButton: "btn btn-danger ml-4",
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            icon: "warning",
            title: "Terms & Conditions",
            html: `<div class="justify-text">By clicking the "I Accept" button displayed as part of the software loading process, you agree to the following terms and conditions (The "agreement") covering your use of the services and the C3 website whether in connection with a paid or trial period subscription. If you are entering into this agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity to these terms and conditions, in which case the terms "you" or "your" shall refer to such entity. If you do not have such authority, or if you do not agree with these terms and conditions, you must select the "I Decline" button and may not use the service. Additionally, by clicking 'I Accept', you consent to receive important messages, alerts, and updates via SMS at the phone number provided.</div>`,
            showCancelButton: true,
            confirmButtonText: "I Accept",
            cancelButtonText: "I Decline",
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.setAcceptTerms();
            } else {
              this.doLogout().then((res) => {
                if (res) {
                  this.$router.push({ path: "/" });
                  window.location.href = `${window.location.origin}`;
                }
              });
            }
          });
      }
    },
    checkSiteHealthy: async function () {
      try {
        const response = await this.$http.get(`healthz`);
        if (!response.data) {
          this.$router.push("/maintenance");
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
@import "assets/scss/theme.scss";
</style>
<style lang="css">
@import "assets/fonts/feather/feather.css";
@import "assets/fonts/ttcommons/ttcommons.css";
@import "assets/css/common.css";
</style>
